import { carouselItems } from '@/mocks/baoliao';

const carouselImages: Record<string, string> = {
  'carousel-01': 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20capital%20market%20manipulation%20concept%20with%20stock%20charts%20and%20spotlights%20merging%2C%20warm%20crimson%20red%20and%20rich%20gold%20tones%2C%20abstract%20cinematic%20style%2C%20dramatic%20editorial%20composition%2C%20mysterious%20atmosphere%20with%20deep%20contrast&width=900&height=500&seq=carousel-01&orientation=landscape',
  'carousel-02': 'https://readdy.ai/api/search-image?query=Tech%20company%20mass%20resignation%20concept%20with%20empty%20office%20chairs%20and%20keyboards%2C%20warm%20amber%20and%20dark%20charcoal%20tones%2C%20abstract%20corporate%20exodus%20style%2C%20dramatic%20empty%20workspace%20aesthetic%2C%20editorial%20business%20trend%20composition&width=900&height=500&seq=carousel-02&orientation=landscape',
  'carousel-03': 'https://readdy.ai/api/search-image?query=Livestream%20shopping%20studio%20with%20multiple%20phone%20screens%20and%20products%2C%20warm%20gold%20and%20dark%20tones%2C%20abstract%20consumer%20investigation%20style%2C%20dramatic%20documentary%20aesthetic%2C%20editorial%20ecommerce%20expose%20composition&width=900&height=500&seq=carousel-03&orientation=landscape',
  'carousel-04': 'https://readdy.ai/api/search-image?query=Offshore%20shell%20company%20network%20concept%20with%20world%20map%20and%20document%20folders%2C%20warm%20crimson%20and%20dark%20charcoal%20tones%2C%20abstract%20financial%20crime%20style%2C%20dramatic%20investigative%20aesthetic%2C%20editorial%20revelation%20composition&width=900&height=500&seq=carousel-04&orientation=landscape',
};

const tagColors: Record<string, string> = {
  '深度专题': 'bg-primary-500',
  '独家策划': 'bg-accent-500',
  '系列追踪': 'bg-primary-500',
  '重磅揭秘': 'bg-accent-500',
};

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            深度专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            编辑团队倾力打造的深度调查与独家策划
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={carouselImages[item.imageSeq]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <span className={`absolute top-4 left-4 px-3 py-1 rounded text-xs font-medium text-background-50 whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-500'}`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 group-hover:text-primary-600 transition-colors mb-3">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  {item.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.reads} 阅读
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}